import { createGlobalStyle } from 'styled-components';
import { lighten } from 'polished';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }
    body {
    height: 100vh;
    -webkit-font-smoothing: antialiased;
  }

  body, button, textarea {
    font-family: ${(props) => props.theme.primaryFont};
    font-size: 13px;
    color: ${(props) => props.theme.colors.gray};
    /* background: ${(props) => lighten(0.38, props.theme.colors.primary)}; */
    
  }

  button {
    border: none;
    background: none;
    cursor: pointer;
  }

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #EEF5FF; 
    border-radius: 5px;
  }
  
  &::-webkit-scrollbar-thumb {
      background: ${(props) => props.theme.colors.primary}; 
      border-radius: 5px;
  }

  .footer-icon path[fill='#0E185B'] {
    fill: ${(props) => props.theme.colors.primaryDark1};
  }

  .toast-icon path {
    fill: ${(props) => props.theme.colors.white};
  }

  .alert-proposal-icon path[fill='#3C50E0'] {
    fill: ${(props) => props.theme.colors.primary};
  }
  svg path[fill='#3C50E0'] {
    fill: ${(props) => props.theme.colors.primary};
  }
  svg path[fill='#0E185B'] {
    fill: ${(props) => props.theme.colors.primaryDark1};
  }
    
  svg .success{
    fill:${(props) => props.theme.colors.white}
  }

  .Toastify__toast {
    width:329px;
    height:94px;
    padding:0;
    box-shadow: -4px 4px 8px rgba(36, 36, 36, 0.4);
  }

  .Toastify__toast-container--top-right {
    top:104px;
    left:calc(100% - 329px);

    @media screen and (max-width:960px){
      top:72px;
    }
  }

  .Toastify__toast--error {
    background:${(props) => props.theme.colors.primaryDark2};
  }

  input[type='number'] {
      -moz-appearance:textfield;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
      -webkit-appearance: none;
  }
`;
